module.exports = __webpack_public_path__ + "img/cvv-info-fr.8bf1e380.svg";